import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const SummaryContainer = styled("div")(({ theme }) => ({
	display: "flex",
	[theme.breakpoints.down("lg")]: {
		width: "95%",
		marginLeft: 0,
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
	},
}));

const cardStyles = {
	width: 230,
	minHeight: "6.3rem",
	backgroundColor: "#002564",
	color: "#fff",
	margin: "0.5rem",
	cursor: "pointer",
	"&:hover": {
		boxShadow:
			"0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%)",
	},
};

const cardContentStyles = {
	padding: "0.5rem",
	height: "100%",
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	"&:last-child": {
		padding: "0.5rem",
	},
};

const SubmissionRequestsSummary = ({ summaryLoading, requestSummary }) => {
	return (
		<div>
			<SummaryContainer>
				<Card
					sx={{
						...cardStyles,
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%" }}
							component="div"
						>
							Total Requests
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
							) : (
								requestSummary.total || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#296DB6",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%" }}
							component="div"
						>
							Total Individual Requests
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
							) : (
								requestSummary.totalIndividualRequests || 0
							)}
						</Typography>
					</CardContent>
				</Card>
				<Card
					sx={{
						...cardStyles,
						backgroundColor: "#4D6692",
					}}
					elevation={0}
				>
					<CardContent
						sx={{
							...cardContentStyles,
						}}
					>
						<Typography
							variant="p"
							sx={{ mb: 1.5, width: "70%" }}
							component="div"
						>
							Total Corporate Requests
						</Typography>
						<Typography align="right" variant="h4">
							{summaryLoading ? (
								<CircularProgress size="1.5rem" sx={{ color: "#fff" }} />
							) : (
								requestSummary.totalCorporateRequests || 0
							)}
						</Typography>
					</CardContent>
				</Card>
			</SummaryContainer>
		</div>
	);
};

export default SubmissionRequestsSummary;
